<div class="component-container">
  <div [class]="class" [style]="{ 'min-width': boxMinWidth }" [class.hover-dark]="asButton" [class.has-btn]="asButton" [class.dark]="inverse">
    @if (asButton) {
      <button class="card-link-overlay" (click)="toClick($event)">
        <span class="sr-only">{{ title }}</span>
      </button>
    }
    <div class="row mb-2">
      <div class="row-inline">
        @if (iconUrl) {
          <img [src]="iconUrl" [width]="iconWidth" alt="" class="mr-5" />
        }
        @if (openDoor) {
          <span class="mr-5">
            <svg fill="#bd3333" width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M 15.875 4 L 15.78125 4.03125 L 7.78125 5.90625 L 7 6.09375 L 7 26.34375 L 7.8125 26.46875 L 15.8125 27.96875 L 15.90625 28 L 18 28 L 18 4 Z M 20 6 L 20 8 L 23 8 L 23 24 L 20 24 L 20 26 L 25 26 L 25 6 Z M 16 6.03125 L 16 26 L 9 24.6875 L 9 7.65625 Z M 14.34375 15 C 13.976563 15 13.65625 15.449219 13.65625 16 C 13.65625 16.550781 13.976563 17 14.34375 17 C 14.710938 17 15 16.550781 15 16 C 15 15.449219 14.710938 15 14.34375 15 Z"
                />
              </svg>
            </span>
          }
          @if (controllerIcon) {
            <span class="mr-5">
              <img width="20" src="https://storage.googleapis.com/yabi-papi-storage/media/icons/gaterix-status/controller.svg" alt="" />
            </span>
          }
          <span class="bold">
            @if (status) {
              <span class="has-status" [class]="status">{{ title }}</span>
            }
            @if (!status) {
              <span>{{ title }}</span>
            }
          </span>
        </div>
        <div class="cell row-inline grid-xsm">
          @if (badge) {
            <div class="cell">
              <span class="status-badge">{{ badge }}</span>
            </div>
          }
          <div class="cell">
            @if (menu && menu.length && (!gateMenu || (gateMenu && !gateMenu.templateRef))) {
              <div>
                <button type="button" class="btn btn-icon primary transparent" (click)="menuEl.toggle($event)" [class.light]="inverse">
                  <i aria-hidden="true" class="icon icon-dotes"></i>
                  <span class="sr-only">Menu</span>
                </button>
                <p-menu appendTo="body" #menuEl [popup]="true" [model]="menu"></p-menu>
              </div>
            }
            @if (gateMenu && gateMenu.templateRef && (!menu || (menu && !menu.length))) {
              <div class="has-float">
                <button type="button" class="btn btn-icon primary transparent" [id]="id" (click)="popoverEl.toggle($event)" [class.light]="inverse">
                  <i aria-hidden="true" class="icon icon-dotes"></i>
                  <span class="sr-only">Menu</span>
                </button>
                <app-popover #popoverEl>
                  <ng-container [ngTemplateOutlet]="gateMenu.templateRef"></ng-container>
                </app-popover>
              </div>
            }
          </div>
        </div>
      </div>
      @if (list && list.length) {
        <div>
          @for (item of list; track item) {
            <div class="mt-3 list-item-label">
              {{ item.title }}: <b>{{ item.value }}</b>
            </div>
          }
        </div>
      }
      <ng-content></ng-content>
    </div>
  </div>
